import { render, staticRenderFns } from "./AppSignUpPwdPage.vue?vue&type=template&id=4045520d&scoped=true"
import script from "./AppSignUpPwdPage.vue?vue&type=script&lang=js"
export * from "./AppSignUpPwdPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4045520d",
  null
  
)

export default component.exports